import { AbstractApi, ApiBaseResponse } from '../../../common/api'
import { Role, RoleDto } from '../../../modules/roles/roles/types/roles-page-types'
import { mapRoleDto } from '../mappers/map-role-dto'
import { CreateRoleDto, UpdateRoleDto } from '../types/role.types'

class RoleApi extends AbstractApi {
  protected url = '/role'

  public async getRoles(): Promise<ApiBaseResponse<Role[]>> {
    const { data: response } = await this.get<ApiBaseResponse<RoleDto[]>>(this.url)

    return {
      ...response,
      data: response.data.map((roleDto) => mapRoleDto(roleDto)),
    }
  }

  public async create(role: CreateRoleDto): Promise<ApiBaseResponse<Role>> {
    const { data: response } = await this.post<ApiBaseResponse<Role>>(this.url, role)

    return response
  }

  public async update(id: number, role: UpdateRoleDto): Promise<ApiBaseResponse<Role>> {
    const { data: response } = await this.put<ApiBaseResponse<Role>>(this.url.concat(`/${id}`), role)

    return response
  }

  public async deleteRole(id: number): Promise<ApiBaseResponse<void>> {
    const { data: response } = await this.delete<ApiBaseResponse<void>>(this.url.concat(`/${id}`))

    return response
  }
}

export const rolesApi = new RoleApi()
